import { render, staticRenderFns } from "./EventNotice.vue?vue&type=template&id=dbe81fd0&scoped=true"
import script from "./EventNotice.vue?vue&type=script&lang=js"
export * from "./EventNotice.vue?vue&type=script&lang=js"
import style0 from "./EventNotice.vue?vue&type=style&index=0&id=dbe81fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe81fd0",
  null
  
)

export default component.exports